import { createContext, useContext } from 'react';
import { useStore } from 'zustand';
import { StoreApi } from 'zustand';

import { UserConfigurationStore } from '@/src/features/app/store/userConfiguration/store';

export const UserConfigurationContext = createContext<StoreApi<UserConfigurationStore> | undefined>(undefined);

export function useUserConfigurationContext<T>(selector: (state: UserConfigurationStore) => T): T;
export function useUserConfigurationContext(): UserConfigurationStore;
export function useUserConfigurationContext<T>(selector?: (state: UserConfigurationStore) => T) {
  const store = useContext(UserConfigurationContext);
  if (!store) throw new Error('UserConfigurationContext not found');
  return useStore(store, selector ?? ((s) => s as unknown as T));
}
